const popularCategories = [
  {
    slug: 'business-intelligence',
    name: 'Business Intelligence',
    href: '/business-intelligence-analytics-software/business-intelligence/',
  },
  { slug: 'crm', name: 'CRM', href: '/customer-management-software/crm/' },
  {
    slug: 'billing-invoicing',
    name: 'Billing Invoicing',
    href: '/finance-accounting-software/billing-invoicing/',
  },
  {
    slug: 'email-management',
    name: 'Email Management',
    href: '/it-communications-software/email-management/',
  },
  {
    slug: 'campaign-management',
    name: 'Campaign Management',
    href: '/marketing-software/campaign-management/',
  },
  {
    slug: 'project-management',
    name: 'Project Management',
    href: '/project-management-planning-software/project-management/',
  },
  {
    slug: 'customer-support',
    name: 'Customer Support',
    href: '/customer-service-support-software/customer-support/',
  },
  {
    slug: 'employee-scheduling',
    name: 'Employee Scheduling',
    href: '/hr-employee-management-software/employee-scheduling/',
  },
  {
    slug: 'it-management',
    name: 'IT Management',
    href: '/it-management-software/it-management/',
  },
  {
    slug: 'scheduling',
    name: 'Scheduling',
    href: '/operations-management-software/scheduling/',
  },
  {
    slug: 'lead-management',
    name: 'Lead Management',
    href: '/sales-software/lead-management/',
  },
];

export { popularCategories };
